import { HTMLAttributes } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { Button } from "../../../../Components/Button";
import { useUser } from "../../../../Hooks/useUser";
import { CampaignSlugViewModel } from "../../Views/[slug]/ViewModel";
import { analytics } from "MVVM/Analytics";

interface IJoinCampaignButtonProps extends HTMLAttributes<HTMLButtonElement> {
  color: string;
  secondaryColor?: string;
  slug: string;
  width?: string;
}

export const JoinCampaignButton = ({
  color,
  secondaryColor,
  slug,
  width,
  ...props
}: IJoinCampaignButtonProps) => {
  const history = useHistory();
  const { allstarUser } = useUser();
  const { exists, joinLeaderboard } = CampaignSlugViewModel(slug);

  return (
    <StyledButton
      size="default"
      width={width}
      color={color}
      textColor={secondaryColor}
      {...props}
      onClick={async () => {
        if (exists?.exists)
          analytics.track("Competition Widget - Visit Click", {});
        else analytics.track("Competition Widget - Join Click", {});

        if (!allstarUser.loggedIn)
          return history.push(`/login?next=${window.location.pathname}`);

        await joinLeaderboard({ variables: { campaign: slug } });

        return history.push(`/competitions/${slug}/play`);
      }}
    >
      {exists?.exists ? "Visit Competition" : "Join Competition"}
    </StyledButton>
  );
};
const StyledButton = styled(Button)<{ color: string; width: string }>`
  color: ${({ textColor, theme }) => textColor || theme.colors.ice};

  z-index: 2;
  font-size: ${({ theme }) => theme.text.subheader.fontSize};

  width: ${(props) => props.width || "200px"};
  background: ${(props) => props.color};

  :hover {
    background: ${(props) => props.color};
    filter: brightness(90%);
  }
`;
